import React, { Component } from "react";
import axios from "axios";

import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem,
  TablePagination
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

class MaterialPaidAmountReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      projectId: "",
      projects: [],
	  
	  projectarray: [],
  projectarrauto: [],
  selectedProject: null,

      page: 0,
      rowsPerPage: 10,
      totalRecords: 0,

      loading: false
    };
  }

  componentDidMount() {
    this.fetchProjects();
    this.fetchPaidRecords();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // PROJECTS
  fetchProjects = () => {
    axios
      .get("http://localhost/xampp/vrbuilders/ajaxprojects.php", {
        params: { action: "getallprojectautoextender" }
      })
      .then((res) => {
        this.setState({ projects: res.data || [] });
      });
  };

  // PAID RECORDS
  fetchPaidRecords = (e) => {
    if (e) e.preventDefault();

    this.setState({ loading: true });

    axios
      .get("http://localhost/xampp/vrbuilders/ajaxmaterialprocurement.php", {
        params: {
          action: "getmaterialpaidamount",
          projectid: this.state.projectId,
          StartIndex: this.state.page,
          PageSize: this.state.rowsPerPage,
          sorting: "mp_id desc"
        }
      })
      .then((res) => {
        this.setState({
          data: res.data || [],
          totalRecords: res.data?.[0]?.count || 0,
          loading: false
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // PAGE CHANGE
  handlePageChange = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.fetchPaidRecords();
    });
  };

  // ROWS CHANGE
  handleRowsChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      () => this.fetchPaidRecords()
    );
  };
  
  
  
  onloadProjectBind = (event) => {
  axios
    .get("http://localhost/xampp/vrbuilders/ajaxprojects.php", {
      params: {
        action: "getallprojectautoextender",
        projectname: event.target.value
      }
    })
    .then((resp) => {
      let strCust = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };

        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );

        if (!found) {
          strCust.push(item);
        }
      });

      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};

onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};



  render() {
    return (
      <Container maxWidth="lg">
        <Paper sx={{ p: 3, mt: 3 }}>

          <Typography variant="h4" color="primary" gutterBottom>
            Paid Material Records
          </Typography>

          {/* FILTER */}
          <Box component="form" onSubmit={this.fetchPaidRecords} sx={{ mb: 3 }}>
  <Grid container spacing={2} alignItems="flex-end">

    {/* Project Dropdown Block */}
   <Grid item xs={12} md={4}>
  <Typography variant="body2" sx={{ mb: 0, color: "text.secondary" }}>
    Project
  </Typography>

<Autocomplete
  options={this.state.projectarrauto}
  value={this.state.selectedProject}
  onChange={this.onProjectChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Project"
      onChange={this.onloadProjectBind}
    />
  )}
  renderOption={(props, option) => (
    <li {...props}>
      {option.title}
    </li>
  )}
  fullWidth
/>
</Grid>

    {/* Styled Action Button Block */}
    <Grid item xs={12} md={2}>
      <Button 
        type="submit" 
        variant="contained"
        size="small"
        sx={{
          backgroundColor: "blue",
          "&:hover": { backgroundColor: "blue" },
          fontWeight: "bold",
          fontSize: "12px",
          height: "32px",
          px: 3,
          borderRadius: "4px",
          width: "100%"
        }}
      >
        SEARCH
      </Button>
    </Grid>

  </Grid>
</Box>



          {/* TABLE */}
          <TableContainer>
            <Table>

              <TableHead>
                <TableRow sx={{ backgroundColor: "#1976d2" }}>
                  <TableCell sx={{ color: "#fff" }}>Material</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Vendor</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Project</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {this.state.data.map((row) => (
                  <TableRow key={row.mp_id} hover>

                    <TableCell>{row.mp_material}</TableCell>
                    <TableCell>{row.vm_vendorname}</TableCell>
                    <TableCell>{row.pj_projectname}</TableCell>

                  </TableRow>
                ))}
              </TableBody>

            </Table>
          </TableContainer>

          {/* PAGINATION */}
          <TablePagination
            component="div"
            count={this.state.totalRecords}
            page={this.state.page}
            onPageChange={this.handlePageChange}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleRowsChange}
          />

        </Paper>
      </Container>
    );
  }
}

export default MaterialPaidAmountReport;